export default {
      id: "arrow-right-usage",
      viewBox: "0 0 38 13",
      url: "../../assets/" + "sprite.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }